import { toJS } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Clause as ImmutableClause } from '#utils/clause/records/Clause';
import { createClause } from '#utils/clause/records/Clause';

import type { AggregateRule } from './types';

export const createAggregateRule = (props: Partial<AggregateRule> = {}): AggregateRule => {
  const jsProps = toJS(props);
  return {
    _key: '',
    _id: '',
    clause: undefined,
    clauseId: '',
    trackEvents: false,
    ruleId: '',
    variationId: '',
    rolloutWeights: undefined,
    rolloutBucketBy: undefined,
    rolloutContextKind: undefined,
    description: undefined,
    kind: '',
    experimentAllocation: undefined,
    disabled: false,
    ...jsProps,
    clauses: (jsProps.clauses?.filter((c): c is ImmutableClause => c !== null) ?? []).map(createClause),
  };
};
